import ModalEquiposAdicionalesVentaUbicacion from "@/erp/inventario/ingreso-producto/shared/componente/ModalEquiposAdicionalesVentaUbicacion";
import ModalCuotas from "@/erp/sale/asesor/preventa/shared/component/modal_cuotas/ModalCuotas";
import { CUOTAS_CHOICE, gridSizeConst1, gridSizeConst4, gridSizeConst6, gridSizeMdLg12, gridSizeMdLg4 } from "@/shared";
import { useFetchGetAllSeries } from "@/shared/actions/erp/productofactorserie.actions";
import { CustomAutocompleteArrStringNoForm, CustomAutocompleteNoForm, SingleIconButton } from "@/shared/components/ui";
import { IDataProducto, IEquipoServicioAdicionales, IPaymentMethod, OrdenTrabajo, TipoVentaEnum } from "@/shared/interfaces";
import { IDataSerie } from "@/shared/interfaces/erp/administration/productofactorserie.interface";
import { useEquiposAdicionales } from "@/store/erp";
import { usePaymentMethodsStore } from "@/store/erp/system-settings/payment-methods";
import { Delete, Visibility } from "@mui/icons-material";
import { Autocomplete, Button, CircularProgress, Grid, IconButton, TextField, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { UseFormReturn } from "react-hook-form";
// import { toast } from "react-toastify";

type Props = {
    form: UseFormReturn<Partial<OrdenTrabajo> & { equipoActualSeleccionado?:string}>
    onlyShow?:boolean;
    showChooseSerie?:boolean;
}

export const EquiposAdicionalesParaVentaActivaciones = ({form, onlyShow=false, showChooseSerie=false}: Props) => {

    const [reloadItems, setReloadItems] = useState(false)
    // const [serieSeleccionada, setSerieSeleccionada] = useState<string | null>(null)

    const equipoActualSeleccionado = form.watch()?.equipoActualSeleccionado

    const productos = useEquiposAdicionales(s => s.productos)
    const setMaterialesEquiposAdicionales = useEquiposAdicionales(s => s.setProductos)
    const handleAgregarProductoNoRestriction = useEquiposAdicionales(s => s.handleAgregarProductoNoRestriction)
    const handleActualizarProductoByKey = useEquiposAdicionales(s => s.handleActualizarProductoByKey)
    const getDataProducto = useEquiposAdicionales(s => s.getDataProducto)
    const handleEliminarProductoByKey = useEquiposAdicionales(s => s.handleEliminarProductoByKey)

    const {
        // getpaymentMethodsFilterPaging,
        paymentMethodsFilterPaging: paymentMethods,
    } = usePaymentMethodsStore()

    const {
      data: seriesData,
      isLoading: isLoadingSeries,
    } = useFetchGetAllSeries({
      enabled: !!equipoActualSeleccionado && !!form.watch().flota_data?.ubicacion,
      params: {
        ubicacion: form.getValues().flota_data?.ubicacion,
        producto: equipoActualSeleccionado,
        page_size: 1000
      }
    })
    // const handleSetAllProductos = useEquiposAdicionales(s => s.handleSetAllProductos)

    useEffect(() => {
        if(form.getValues().materiales_equipos_adicionales 
        && (form.getValues()?.materiales_equipos_adicionales?.length||0)>0){
          setMaterialesEquiposAdicionales(form.getValues()?.materiales_equipos_adicionales)
            // handleSetAllProductos(form.getValues()?.materiales_equipos_adicionales)
        }else{
          setMaterialesEquiposAdicionales([])
        }
    }, []);
    useEffect(() => {
        form.reset({
            ...form.getValues(),
            materiales_equipos_adicionales: productos,
            routers_adicionales_instalados: productos.filter(e => e.descripcion!.toUpperCase().includes("ROUTER")).length||0,
        })
        console.log({productos})
    }, [productos]);


    return (
    <>

    <Grid {...gridSizeMdLg12} container justifyContent={"end"}>
        <ModalEquiposAdicionalesVentaUbicacion
          textButton="Agregar"
          onlyShow={onlyShow}
          ubicacionFlota={form.getValues()?.flota_data?.ubicacion}
          queryStringToSearch="descripcion_producto"
          onChange={(e) => {
            const value = e as IDataProducto
            let repeatedItemNumber = productos.filter(inlist => inlist.id == value.id_producto).length + 1
            const nuevoProducto: IEquipoServicioAdicionales = {
              id: value.id_producto,
              codigo: value.codigo,
              cantidad: "1",
              cuotas: "1",
              tipoVenta: TipoVentaEnum.EQUIPO,
              precios: value.precios,
              descripcion: value.descripcion+" #"+repeatedItemNumber,
            };

            handleAgregarProductoNoRestriction(nuevoProducto)

          }}
        />
      </Grid>
      <Grid item xs={12}>
        <Grid
          item
          container
          spacing={2}
          
          // justifyContent={"space-between"}
          {...gridSizeMdLg12}
          sx={{
            "& > .item-equipoadicional-activaciones:first-of-type": {
              boxShadow:"0px 0px 2px 2px #ddd",
              borderRadius:"8px 8px 0px 0px"
            },
            "& > .item-equipoadicional-activaciones:not(:first-of-type)": {
              boxShadow:"0px 0px 2px 2px #ddd",
            },
            "& > .item-equipoadicional-activaciones:last-of-type": {
              boxShadow:"0px 0px 2px 2px #ddd",
              borderRadius:"0px 0px 8px 8px"
            },
          }}
        >
          { reloadItems && productos && productos?.length>0?
          <Grid {...gridSizeMdLg12} display={"flex"} alignItems={"center"} justifyContent={"center"}>
            <CircularProgress size={20}/>
          </Grid>
          :
          <>
            {
              productos.filter(e => e.tipoVenta == TipoVentaEnum.EQUIPO).map((element, index) => {
                return <Grid
                  className="item-equipoadicional-activaciones"
                  item
                  container
                  spacing={2}
                  {...gridSizeMdLg12}
                  key={`${element.codigo}-${index}`}
                  sx={{paddingBottom:2, marginLeft:3, marginTop:.5}}
                >

                  <Grid item {...gridSizeConst6}>
                    <Typography variant="subtitle2">
                      {element.descripcion}
                    </Typography>
                  </Grid>

                  {/* <CustomAutocompleteArrStringNoForm
                    label="Cantidad"
                    options={                  size={gridSizeConst2}
                    defaultValue={element.cantidad ?? '1'}
                    onChangeValue={(value) => {
                      handleActualizarProductoByKey(element.id!, { cantidad: value })
                    }}
                    disabled={onlyShow}
                  /> */}

                  <CustomAutocompleteArrStringNoForm
                    label="Cuotas"
                    options={CUOTAS_CHOICE}
                    size={gridSizeConst4}
                    defaultValue={element.cuotas ?? '1'}
                    onChangeValue={(value) => {
                      handleActualizarProductoByKey("descripcion",element.descripcion!, { cuotas: value })
                    }}
                    disabled={onlyShow}
                  />

                  <Grid item {...gridSizeConst1}>
                    <SingleIconButton
                      startIcon={<Visibility />}
                      label="Ver valores de cuotas"
                      onClick={() => {
                        const findProducto = productos.find(e => e.descripcion == element.descripcion!);
                        getDataProducto(findProducto);
                      }}
                    />
                  </Grid>
                  {
                    !onlyShow &&
                    <Grid item {...gridSizeConst1}>
                      <IconButton
                        onClick={() => {
                          handleEliminarProductoByKey("descripcion",element.descripcion!);
                          setReloadItems(true)
                          setTimeout(() => {
                            setReloadItems(false)
                          }, 400);
                      }}
                    >
                      <Delete />
                    </IconButton>
                  </Grid>
                  }
                  <Grid {...gridSizeMdLg12} item container px={2}>
                    <CustomAutocompleteNoForm<IPaymentMethod>
                      size={gridSizeMdLg12}
                      label={"Forma de Pago"}
                      options={paymentMethods || []}
                      valueKey="alias"
                      actualValueKey="codigo"
                      defaultValue={element.forma_pago || ""}
                      isLoadingData={false}
                      onChangeRawValue={(valuesFormaPago) => {
                        handleActualizarProductoByKey("descripcion", element.descripcion!, { forma_pago: valuesFormaPago })
                      }}
                      disabled={onlyShow}
                    />
                    {/* <FormaPago form={form} 
                    onChangeData={(valuesData) => {
                      handleActualizarProductoByKey(element.id!, { forma_pago: valuesData })
                    }}
                    onlyShow={form.getValues()?.estado_activacion==EstadosActivacionInstallOTEnumChoice.GESTIONADA}
                    /> */}
                  </Grid>
                  {
                    showChooseSerie &&
                    (
                      <>
                        <Grid {...gridSizeMdLg12} item container px={2} spacing={2}>
                          <Grid item container {...gridSizeMdLg4} justifyContent={"center"}>
                            <Button
                              onClick={() => {
                                form.reset({
                                  ...form.getValues(),
                                  equipoActualSeleccionado: element.codigo
                                })
                              }}
                              variant="contained"
                              fullWidth
                            >
                              Cargar Series
                            </Button>
                          </Grid>
                          <SerieAutocomplete
                            series={seriesData?.data?.data || []}
                            selectedSerie={element.series?.[0] ?? null}
                            disabledSeries={productos.map(p => p.series?.[0] ?? "").filter(Boolean)}
                            isLoadingSeries={isLoadingSeries}
                            onSelectSerie={(serie) => {
                              handleActualizarProductoByKey(
                                "descripcion",
                                element.descripcion!,
                                { series: [serie] }
                              );
                              console.log({productos})
                            }}
                            disabled={equipoActualSeleccionado !== element.codigo}
                          />

                        </Grid>
                      </>
                    )
                  }
                </Grid>
              })
            }
          </>
          }
          {
            productos && productos?.length==0 &&
            <Grid item container>
              <Typography variant="body1" color={"gray"}>
                Aún no se han añadido equipos adicionales
              </Typography>
            </Grid>
          }

        </Grid>
        <ModalCuotas />
      </Grid>



    </>
  )
}





// import { Autocomplete, TextField, Grid } from "@mui/material";

type PropsAutocompleteSerie = {
  series: IDataSerie[];
  selectedSerie: string | null;
  disabledSeries: string[]; // series repetidas globales
  onSelectSerie: (serie: string) => void;
  disabled?: boolean;
  isLoadingSeries?: boolean;
};

const SerieAutocomplete = ({
  series,
  selectedSerie,
  disabledSeries,
  onSelectSerie,
  disabled = false,
  isLoadingSeries = false,
}: PropsAutocompleteSerie) => {

  // Opciones con deshabilitado si ya existen (pero permite la actual)
  const options = useMemo(() => {
    return series.map((item) => ({
      ...item,
      isDisabled: disabledSeries.includes(item.serie) && item.serie !== selectedSerie,
    }));
  }, [series, disabledSeries, selectedSerie]);

  return (
    <Grid item xs={12} md={8}>
      <Autocomplete
        value={{ serie: selectedSerie||"" } as any}
        loading={isLoadingSeries}
        options={options}
        getOptionDisabled={(opt) => opt.isDisabled}
        getOptionLabel={(opt) => opt.serie}
        disabled={disabled}
        onChange={(_, data) => {
          if (!data) return;
          if (data.isDisabled) return;
          onSelectSerie(data.serie);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Serie a Instalar"
            variant="outlined"
            disabled={disabled}
          />
        )}
      />
    </Grid>
  );
};